export const validateTrapData = (trap) =>
  trap.frontImageUrl &&
  trap.backImageUrl &&
  trap.captureDate &&
  trap.vegetativeStage;
